import { useEffect } from "react";
import Head from "next/head";
import styled from "styled-components";
import Layout from "../../components/Layout";
import { getAllProducts } from "../../lib/shopify";
import { request } from "../../lib/datocms";
import WorkIndex from "../../components/WorkIndex";
import { useStore } from "../_app";

export async function getStaticProps() {
  const data = await getAllProducts();
  const globalSettings = await request({
    query: `query GlobalSettings {
      global {
        pauseAllSales
        newDropDate
      },
    }`,
  });

  return {
    props: {
      data,
      globalSettings,
    },
    revalidate: 10,
  };
}

export default function ShopifyWorkPage({ data, globalSettings }) {
  const setHeaderOpaque = useStore((state) => state.setHeaderOpaque);

  useEffect(() => {
    setHeaderOpaque();
  }, []);

  return (
    <Layout>
      <Head>
        <title>veikkanen - Work</title>
      </Head>
      <WorkIndex
        products={data}
        globalSettings={globalSettings}
        spacingTop="small"
      />
    </Layout>
  );
}
